import React, { Suspense, lazy, useContext } from "react";
import "./checkout.css";
import arrow from "../../assets/images/arrow.svg";
import card from "../../assets/images/card.svg";
import car1 from "../../assets/images/car1.png";
import arrow1 from "../../assets/images/arrow1.svg";
import yellowStar from "../../assets/images/yellowstar.svg";
import reviews from "../../assets/images/reviews.svg";
import starfull from "../../assets/images/starfull.svg";
import { Link, useLocation, useParams } from "react-router-dom";
// import {Button, Modal} from 'react-bootstrap';
import { useEffect, useState } from "react";
import { API } from "../../utils/api";
import { Accordion } from "react-bootstrap";
import { DataContext } from "../../context/dataContext";
import mastercard from "../../assets/images/mastercard.svg";
import visa from "../../assets/images/visa.svg";
import reviews1 from "../../assets/images/reviews1.svg";
import PlateViewer from "../plateviewer/plateviewer";

import Loader from "../../components/Loader";
import Plate from "../plateviewer/Plate";
import { Helmet } from "react-helmet";
// import { GolfFront } from "../../components/cars/front/Golf";
// import { GolfRear } from "../../components/cars/rear/Golf";
// import { MFront } from "../../components/cars/front/M2";
// import { MRear } from "../../components/cars/rear/M2";

const GolfFront = lazy(() => import("../../components/cars/front/Golf"));
const GolfRear = lazy(() => import("../../components/cars/rear/Golf"));
const MFront = lazy(() => import("../../components/cars/front/M2"));
const MRear = lazy(() => import("../../components/cars/rear/M2"));

// import {
//   RequestType,
//   fromLatLng,
//   geocode,
//   setDefaults,
//   setKey,
// } from 'react-geocode';
// import {loadStripe} from '@stripe/stripe-js';

// import {

//   Elements,
//   PaymentElement,
// } from '@stripe/react-stripe-js';
// import Paymentform from '../../components/Paymentform';

// const stripePromise = loadStripe('pk_test_51OWGxHBkCSDQh61WR1MNXMZEg4iut0KwSYRqoMRW0qGnKgJPeUsIXPCnssQDPutdAuvFEYaTUmyimQdK6jBdOpat00JE4KRXT1');

const Checkout = () => {
  const params = useParams();
  const dataContext = useContext(DataContext);
  const [data, setData] = useState();
  const [FAQs, setFAQs] = useState([]);
  const [amount, setAmount] = useState({
    total: 0,
    vat: 0,
    sales: 0,
  });
  // const [coordinates, setCoordinates] = useState(null);
  // const [clientSecret, setClientSecret] = useState('');
  // const [paymentModel, setPaymentModel] = useState(false);

  console.log("data", data?.reg);

  useEffect(() => {
    document.querySelector("body").scrollTo(0, 0);
    // setKey('AIzaSyBoAW5AwRU_O7fMVLYKLM0ZzTtMJuc2fb8');
    // getMyLocation();
    dataContext?.setLoading(true);
    API(`regs?id=${params?.id}`, "get", "", "")
      .then((res) => {
        console.log("chckout res: ", res);
        // dataContext?.setLoading(true);
        setData(res?.data);
        const isVAT = res?.data?.vat;
        const sales = res?.data?.sales;
        const vat = isVAT ? sales * 0.2 : 0;
        const total = sales + vat + 80;
        const deposit =
          total < 5000 ? total : total * 0.1 > 5000 ? 5000 : total * 0.1;
        setAmount({
          total: total,
          vat: vat,
          sales: sales,
          deposit: deposit,
        });
        setFAQs(res?.data?.faq);
        dataContext?.setLoading(false);
      })
      .catch((e) => {
        dataContext?.setLoading(false);
        console.log("get data error: ", e);
      });

    // getFAQData();

    const script = document.createElement("script");
    script.src =
      "https://widget.reviews.io/carousel-inline-iframeless/dist.js?_t=2023122906";
    script.async = true;
    document.body.appendChild(script);

    const options = {
      /*Your REVIEWS.io account ID:*/
      store: "reg247.co.uk",
      sku: "",
      lang: "en",
      carousel_type: "default",
      styles_carousel: "CarouselWidget--sideHeader",

      /*Widget settings:*/
      options: {
        general: {
          /*What reviews should the widget display? Available options: company, product, third_party. You can choose one type or multiple separated by comma.*/
          review_type: "company, product",
          /*Minimum number of reviews required for widget to be displayed*/
          min_reviews: "1",
          /*Maximum number of reviews to include in the carousel widget.*/
          max_reviews: "20",
          address_format: "CITY, COUNTRY",
          /*Carousel auto-scrolling speed. 3000 = 3 seconds. If you want to disable auto-scroll, set this value to false.*/
          enable_auto_scroll: 10000,
        },
        header: {
          /*Show overall rating stars*/
          enable_overall_stars: true,
          rating_decimal_places: 2,
        },
        reviews: {
          /*Show customer name*/
          enable_customer_name: true,
          /*Show customer location*/
          enable_customer_location: true,
          /*Show "verified review" badge*/
          enable_verified_badge: true,
          /*Show "verified subscriber" badge*/
          enable_subscriber_badge: true,
          /*Show "I recommend this product" badge (Only for product reviews)*/
          enable_recommends_badge: true,
          /*Show photos attached to reviews*/
          enable_photos: true,
          /*Show videos attached to reviews*/
          enable_videos: true,
          /*Show when review was written*/
          enable_review_date: true,
          /*Hide reviews written by the same customer (This may occur when customer reviews multiple products)*/
          disable_same_customer: true,
          /*Minimum star rating*/
          min_review_percent: 4,
          /*Show 3rd party review source*/
          third_party_source: true,
          /*Hide reviews without comments (still shows if review has a photo)*/
          hide_empty_reviews: true,
          /*Show product name*/
          enable_product_name: true,
          /*Show only reviews which have specific tags (multiple semicolon separated tags allowed i.e tag1;tag2)*/
          tags: "",
          /*Show branch, only one input*/
          branch: "",
          enable_branch_name: false,
        },
        popups: {
          /*Make review items clickable (When they are clicked, a popup appears with more information about a customer and review)*/
          enable_review_popups: true,
          /*Show "was this review helpful" buttons*/
          enable_helpful_buttons: true,
          /*Show how many times review was upvoted as helpful*/
          enable_helpful_count: true,
          /*Show share buttons*/
          enable_share_buttons: true,
        },
      },
      translations: {
        verified_customer: "Verified Customer",
      },
      styles: {
        /*Base font size is a reference size for all text elements. When base value gets changed, all TextHeading and TexBody elements get proportionally adjusted.*/
        "--base-font-size": "16px",
        "--base-maxwidth": "100%",

        /*Logo styles:*/
        "--reviewsio-logo-style": "var(--logo-normal)",

        /*Star styles:*/
        "--common-star-color": " #FDD405",
        "--common-star-disabled-color": " rgba(0,0,0,0.25)",
        "--medium-star-size": " 22px",
        "--small-star-size": "19px" /*Modal*/,
        "--x-small-star-size": "16px",
        "--x-small-star-display": "inline-flex",

        /*Header styles:*/
        "--header-order": "1",
        "--header-width": "160px",
        "--header-bg-start-color": "transparent",
        "--header-bg-end-color": "transparent",
        "--header-gradient-direction": "135deg",
        "--header-padding": "0.5em",
        "--header-border-width": "0px",
        "--header-border-color": "rgba(0,0,0,0.1)",
        "--header-border-radius": "0px",
        "--header-shadow-size": "0px",
        "--header-shadow-color": "rgba(0, 0, 0, 0.1)",

        /*Header content styles:*/
        "--header-star-color": "inherit",
        "--header-disabled-star-color": "inherit",
        "--header-heading-text-color": "inherit",
        "--header-heading-font-size": "inherit",
        "--header-heading-font-weight": "inherit",
        "--header-heading-line-height": "inherit",
        "--header-heading-text-transform": "inherit",
        "--header-subheading-text-color": "inherit",
        "--header-subheading-font-size": "inherit",
        "--header-subheading-font-weight": "inherit",
        "--header-subheading-line-height": "inherit",
        "--header-subheading-text-transform": "inherit",

        /*Review item styles:*/
        "--item-maximum-columns": "5" /*Must be 3 or larger*/,
        "--item-background-start-color": "transparent",
        "--item-background-end-color": "transparent",
        "--item-gradient-direction": "135deg",
        "--item-padding": "0.5em",
        "--item-border-width": "0px",
        "--item-border-color": "rgba(0,0,0,0.1)",
        "--item-border-radius": "0px",
        "--item-shadow-size": "0px",
        "--item-shadow-color": "rgba(0,0,0,0.1)",

        /*Heading styles:*/
        "--heading-text-color": " #0E1311",
        "--heading-text-font-weight": " 600",
        "--heading-text-font-family": " inherit",
        "--heading-text-line-height": " 1.4",
        "--heading-text-letter-spacing": "0",
        "--heading-text-transform": "none",

        /*Body text styles:*/
        "--body-text-color": " #0E1311",
        "--body-text-font-weight": "400",
        "--body-text-font-family": " inherit",
        "--body-text-line-height": " 1.4",
        "--body-text-letter-spacing": "0",
        "--body-text-transform": "none",

        /*Scroll button styles:*/
        "--scroll-button-icon-color": "#0E1311",
        "--scroll-button-icon-size": "24px",
        "--scroll-button-bg-color": "transparent",

        "--scroll-button-border-width": "0px",
        "--scroll-button-border-color": "rgba(0,0,0,0.1)",

        "--scroll-button-border-radius": "60px",
        "--scroll-button-shadow-size": "0px",
        "--scroll-button-shadow-color": "rgba(0,0,0,0.1)",
        "--scroll-button-horizontal-position": "0px",
        "--scroll-button-vertical-position": "0px",

        /*Badge styles:*/
        "--badge-icon-color": "#0E1311",
        "--badge-icon-font-size": "15px",
        "--badge-text-color": "#0E1311",
        "--badge-text-font-size": "inherit",
        "--badge-text-letter-spacing": "inherit",
        "--badge-text-transform": "inherit",

        /*Author styles:*/
        "--author-font-size": "inherit",
        "--author-font-weight": "inherit",
        "--author-text-transform": "inherit",

        /*Product photo or review photo styles:*/
        "--photo-video-thumbnail-size": "60px",
        "--photo-video-thumbnail-border-radius": "0px",

        /*Popup styles:*/
        "--popup-backdrop-color": "rgba(0,0,0,0.75)",
        "--popup-color": "#ffffff",
        "--popup-star-color": "inherit",
        "--popup-disabled-star-color": "inherit",
        "--popup-heading-text-color": "inherit",
        "--popup-body-text-color": "inherit",
        "--popup-badge-icon-color": "inherit",
        "--popup-badge-icon-font-size": "19px",
        "--popup-badge-text-color": "inherit",
        "--popup-badge-text-font-size": "14px",
        "--popup-border-width": "0px",
        "--popup-border-color": "rgba(0,0,0,0.1)",
        "--popup-border-radius": "0px",
        "--popup-shadow-size": "0px",
        "--popup-shadow-color": "rgba(0,0,0,0.1)",
        "--popup-icon-color": "#0E1311",

        /*Tooltip styles:*/
        "--tooltip-bg-color": "#0E1311",
        "--tooltip-text-color": "#ffffff",
      },
    };

    const handleScriptLoad = () => {
      window?.carouselInlineWidget("reviewsio-carousel-widget", options);
    };

    script.addEventListener("load", handleScriptLoad);

    return () => {
      script.removeEventListener("load", handleScriptLoad);
      document.body.removeChild(script);
    };
  }, []);

  // useEffect(() => {
  //   if(data && coordinates){
  //     onSecureRegistration();
  //   }
  // }, [data, coordinates]);

  function formatNumber(num) {
    // Convert the number to a string, handling different input types
    var numberString = typeof num === "number" ? num.toString() : String(num);

    // Handle non-decimal numbers by adding ".00"
    if (!numberString.includes(".") && numberString !== "0") {
      numberString += ".00";
    }

    // Split the number into integer and decimal parts
    var parts = numberString.split(".");

    // Format the integer part with commas using Intl.NumberFormat
    var formatter = new Intl.NumberFormat("en-US");
    var formattedInteger = formatter.format(parseInt(parts[0], 10));

    // Combine the formatted integer and decimal parts
    var formattedNumber = formattedInteger + (parts[1] ? "." + parts[1] : "");

    return formattedNumber;
  }

  // const getFAQData = () => {
  //   API(`faq?type=1`, "get", "", "")
  //     .then((res) => {
  //       console.log("faq: ", res?.data)
  //       setFAQs(res?.data);
  //     })
  //     .catch((e) => console.log("error faq: ", e));
  // };

  const totalAmount = data?.vat ? data?.sales + vat + 80 : data?.sales + 80;

  function removeCommas(numberString) {
    return parseFloat(numberString.replace(/,/g, ""));
  }

  const vattotalAmount = data?.vat
    ? formatNumber(parseFloat(Number(data?.sales)).toFixed(2))
    : formatNumber(parseFloat(Number(data?.sales)).toFixed(2));

  function removeCommas(numberString) {
    return parseFloat(numberString.replace(/,/g, ""));
  }

  const formattedNumber = vattotalAmount;
  const total = removeCommas(formattedNumber);
  console.log(total);

  // Function to calculate VAT
  function calculateVAT(amount) {
    return amount * 0.2;
  }
  // var amount = total;
  var vat = data?.sales * 0.2;
  // const deposit = removeCommas(totalAmount);
  // var tenPercent = deposit * 0.1;
  console.log("vatAmount --------->", vat);

  const cars = [
    {
      id: 15,
      name: "Golf Front",
      component: (
        <Suspense fallback={<Loader />}>
          <GolfFront numberPlate={data?.reg} />
        </Suspense>
      ),
    },
    {
      id: 16,
      name: "Golf Rear",
      component: (
        <Suspense fallback={<Loader />}>
          <GolfRear numberPlate={data?.reg} />
        </Suspense>
      ),
    },
    {
      id: 17,
      name: "M2 Front",
      component: (
        <Suspense fallback={<Loader />}>
          <MFront numberPlate={data?.reg} />
        </Suspense>
      ),
    },
    {
      id: 18,
      name: "M2 Rear",
      component: (
        <Suspense fallback={<Loader />}>
          <MRear numberPlate={data?.reg} />
        </Suspense>
      ),
    },
  ];

  return (
    <div className="main__page__content reg__checkout-main ">
      <Helmet>
        <meta charSet="utf-8" />
        <title>{`Buy ${params?.id} Registration`}</title>
      </Helmet>
      <main>
        <div className="reg__checkout--details">
          <div className="container">
            {data?.reg ? null : <Loader />}
            <div className="row align-center">
              <div className="col-12 col-lg-6">
                <div className="reg__checkout--number">
                  <div className="reg__checkout--plat">
                    <div className="reg__plate--data fun yellow-bg br4 mb-25">
                      <h1 className="lh60">{data?.reg}</h1>
                    </div>
                    <div className="reg__plate--text mb-35">
                      <p className="text-center fsi mb-0">{data?.displaymsg}</p>
                    </div>
                    <div className="reg__plate--title">
                      <div className="d-flex justify-between fsi text-400">
                        <p className="mb-0">Registration:</p>
                        <p className="mb-0">
                          £{formatNumber(parseFloat(amount.sales).toFixed(2))}
                        </p>
                      </div>
                      {data?.vat && (
                        <>
                          <div className="reg__price--line"></div>
                          <div className="d-flex justify-between fsi text-400">
                            <p className="mb-0">VAT:</p>
                            <p className="mb-0">
                              £{formatNumber(parseFloat(amount.vat).toFixed(2))}
                            </p>
                          </div>
                        </>
                      )}
                      {/* <div className="reg__price--line"></div>
                      <div className="d-flex justify-between fsi text-400">
                        <p className="mb-0">Turbocharged Transfer Service</p>
                        <p className="mb-0">£16.66</p>
                      </div> */}
                      <div className="reg__price--line"></div>
                      <div className="d-flex justify-between fsi text-400">
                        <div className="d-flex gap-2  align-items-center">
                          <p className="mb-0">Compulsory DVLA Fee </p>
                          {/* <div>
                            <svg
                              className="d-block"
                              width="12"
                              height="12"
                              viewBox="0 0 12 12"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <g clipPath="url(#clip0_91_1360)">
                                <path
                                  d="M11.8125 6C11.8125 9.21087 9.20993 11.8125 6 11.8125C2.79007 11.8125 0.1875 9.21087 0.1875 6C0.1875 2.79101 2.79007 0.1875 6 0.1875C9.20993 0.1875 11.8125 2.79101 11.8125 6ZM6.15598 2.10938C4.8787 2.10938 4.06406 2.64743 3.42436 3.6037C3.34148 3.72759 3.36921 3.89468 3.48799 3.98475L4.30125 4.60139C4.42324 4.6939 4.59705 4.67189 4.69184 4.55166C5.11052 4.02061 5.39761 3.71266 6.03487 3.71266C6.51368 3.71266 7.10592 4.02082 7.10592 4.48512C7.10592 4.83612 6.81616 5.01638 6.34341 5.28143C5.79206 5.5905 5.0625 5.97518 5.0625 6.9375V7.03125C5.0625 7.18657 5.18843 7.3125 5.34375 7.3125H6.65625C6.81157 7.3125 6.9375 7.18657 6.9375 7.03125V7.00001C6.9375 6.33293 8.88717 6.30516 8.88717 4.5C8.88717 3.14058 7.47705 2.10938 6.15598 2.10938ZM6 7.92188C5.40551 7.92188 4.92188 8.40551 4.92188 9C4.92188 9.59447 5.40551 10.0781 6 10.0781C6.59449 10.0781 7.07812 9.59447 7.07812 9C7.07812 8.40551 6.59449 7.92188 6 7.92188Z"
                                  fill="black"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_91_1360">
                                  <rect width="12" height="12" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          </div> */}
                        </div>
                        <p className="mb-0">£80.00</p>
                      </div>
                      <div className="reg__price--line"></div>
                      <div className="d-flex justify-between text-400">
                        <p className="mb-0 fsi f20">Total</p>
                        <p className="mb-0 fsi f20">
                          £{formatNumber(parseFloat(amount.total).toFixed(2))}
                        </p>
                      </div>
                      <div className="reg__price--greenline"></div>
                      <div className="d-flex justify-between text-400">
                        <p className="mb-0 fsi f20">Total to pay today:</p>
                        <p className="mb-0 fsi f20">
                          £{formatNumber(Number(amount.deposit).toFixed(2))}
                        </p>
                      </div>
                      <div className="reg__price--greenline" />
                    </div>
                    <div className="reg__checkout--button fsi">
                      <div className="buy-btn mb-20 p-0">
                        <Link
                          to={`/secure-your-reg/${data?.reg}`}
                          onClick={() => {
                            dataContext?.setSearchKey("");
                          }}
                          className="d-flex align-items-center w-100 justify-content-center"
                          // onClick={() => setPaymentModel(true)}
                        >
                          SECURE YOUR REG
                          <svg
                            width="36"
                            height="8"
                            viewBox="0 0 36 8"
                            fill="white"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M35.3536 4.35355C35.5488 4.15829 35.5488 3.84171 35.3536 3.64645L32.1716 0.464466C31.9763 0.269204 31.6597 0.269204 31.4645 0.464466C31.2692 0.659728 31.2692 0.976311 31.4645 1.17157L34.2929 4L31.4645 6.82843C31.2692 7.02369 31.2692 7.34027 31.4645 7.53553C31.6597 7.7308 31.9763 7.7308 32.1716 7.53553L35.3536 4.35355ZM0 4.5H35V3.5H0V4.5Z"
                              fill="black"
                            />
                          </svg>
                        </Link>
                      </div>
                      <div className="offer-btn call__checkout--button mb-40 d-flex">
                        <Link
                          to={`/registration-enquiry/${data?.reg}`}
                          onClick={() => {
                            dataContext?.setSearchKey("");
                          }}
                          className="d-flex align-items-center mr-10 text-white w-100 justify-content-center"
                        >
                          MAKE ENQUIRY
                          <svg
                            width="36"
                            height="8"
                            viewBox="0 0 36 8"
                            fill="white"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M35.3536 4.35355C35.5488 4.15829 35.5488 3.84171 35.3536 3.64645L32.1716 0.464466C31.9763 0.269204 31.6597 0.269204 31.4645 0.464466C31.2692 0.659728 31.2692 0.976311 31.4645 1.17157L34.2929 4L31.4645 6.82843C31.2692 7.02369 31.2692 7.34027 31.4645 7.53553C31.6597 7.7308 31.9763 7.7308 32.1716 7.53553L35.3536 4.35355ZM0 4.5H35V3.5H0V4.5Z"
                              fill="black"
                            />
                          </svg>
                        </Link>
                        <a
                          href="tel: 01582 347734"
                          className="d-flex align-items-center text-white w-100 justify-content-center"
                        >
                          01582 347734
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M0 2.66667C0 1.95942 0.280951 1.28115 0.781048 0.781048C1.28115 0.280951 1.95942 0 2.66667 0H7.04C7.31973 0.000212391 7.5923 0.088395 7.81914 0.252067C8.04598 0.415738 8.21561 0.646608 8.304 0.912L10.3013 6.90267C10.4025 7.20712 10.3906 7.53785 10.2676 7.83419C10.1447 8.13053 9.919 8.37261 9.632 8.516L6.62267 10.0227C8.09776 13.2874 10.7126 15.9022 13.9773 17.3773L15.484 14.368C15.6274 14.081 15.8695 13.8553 16.1658 13.7324C16.4621 13.6094 16.7929 13.5975 17.0973 13.6987L23.088 15.696C23.3536 15.7845 23.5846 15.9543 23.7483 16.1814C23.912 16.4085 24.0001 16.6814 24 16.9613V21.3333C24 22.0406 23.719 22.7189 23.219 23.219C22.7189 23.719 22.0406 24 21.3333 24H20C8.95467 24 0 15.0453 0 4V2.66667Z"
                              fill="#0051CC"
                            />
                          </svg>
                        </a>
                      </div>
                    </div>
                    <div className="reg__payment--data justify-content-center">
                      <div className="payment__image">
                        <img src={mastercard} />
                      </div>
                      <div className="payment__image">
                        <img src={visa} />
                      </div>
                      {/* <div className="payment__image">
                  <img src={payment1} />
                </div>
                <div className="payment__image">
                  <img src={safepayment} />
                </div> */}
                      <div className="payment__image">
                        <a
                          rel="noopener" rel="noreferrer" target="_blank"
                          href="https://www.reviews.io/company-reviews/store/reg247.co.uk"
                        >
                          <img src={reviews1} />
                        </a>
                      </div>
                      <div className="payment__image">
                        <img
                          src={require("../../assets/images/poweredbystripe.png")}
                          alt=""
                        />
                      </div>
                    </div>
                    {/* <div className="reg__payment-list text-center">
                      <img src={card} alt="Image" />
                    </div> */}
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg-6">
                <div className="reg__checkout-car">
                  <Plate numberPlate={data?.reg} isProduct cars={cars} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <section className="reg__faq--section reg__check--out-faq">
          <div className="container">
            <div className="faq__heading">
              <h2 className="fys h1 text-300 yellow__line-draw f36 mb-50 text-center">
                Questions About Buying This Private Plate
              </h2>
            </div>
            <Accordion defaultActiveKey={0}>
              {FAQs?.map((item, index) => (
                <Accordion.Item
                  eventKey={index}
                  className="accordion-item border-0 shadow mb-15 bg-body rounded"
                >
                  <Accordion.Header className="accordion-header fsi" id="work">
                    {item?.question}
                  </Accordion.Header>
                  <Accordion.Body
                    id={`workdata${index}`}
                    className="accordion-collapse fsi ms-4"
                  >
                    <span
                      dangerouslySetInnerHTML={{
                        __html: item?.answer,
                      }}
                    ></span>
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </div>
        </section>
        <div className="reg__checkout--data">
          <div className="reg__checkout--manage d-inline-block w-100 mt-64 text-center fsi tr-management">
            <div className="container">
              <h5 className="text-center text-300 fys color-black mb-50 green--line">
                Transfer Information & Plate Printing
              </h5>
              <p className="mb-30" style={{textAlign: "left"}}>
                Our Turbocharged Transfer Service includes the following:
                <ul className="list_style">
                  <li>
                    Quick Service - the transfer is completed as soon as
                    possible.
                  </li>
                  <li>Assign the plate onto a vehicle of your choice.</li>
                  <li>
                    Choose the exact date you would like the plate assigned
                    (perfect for presents.)
                  </li>
                  <li>
                    Documents posted to you using Royal Mail recorded delivery.
                  </li>
                  <li>
                    No hassle, we deal with all the complications, DVLA and
                    transferring Tax/ MOT information.
                  </li>
                  <li>
                    Confidence that a professional is completing the transfer
                    for you.
                  </li>
                </ul>
              </p>
              <p className="mb-30" style={{textAlign: "left"}}>
                We supply superior quality 2D and 4D acrylic number plates for
                all vehicles.{" "}
                <a
                  href="https://www.reg247.co.uk/buy-number-plates"
                  rel="noopener" rel="noreferrer" target="_blank"
                  className="link_site"
                >
                  See our acrylic number plates here.
                </a>
              </p>
            </div>
          </div>
          <div className="container">
            <div className="reg__checkout--manage d-inline-block w-100 mtb-56 text-center fsi ">
              <h5 className="text-center text-300 fys color-black mb-50 green--line">
                No vehicle to assign the plate onto?
              </h5>
              <p className="mb-30">
                In some instances, we would need to assign a number plate
                directly onto the purchaser’s vehicle to get it out of the
                seller’s name. If you do not have a vehicle to use then give us
                a call to discuss using a one of our company vehicles.
              </p>
            </div>
          </div>
        </div>
        <div className="reg__review--section reg__checkout--review">
          <div className="container">
            <h5 className="text-center text-300 fsi text-400 color-black mb-50 green--line">
              Latest Customer Reviews
            </h5>
            <div className="reg__review--data">
              <div className="row align-center">
                <div id="reviewsio-carousel-widget"></div>
              </div>
            </div>
          </div>
        </div>

        {/* <Modal show={paymentModel} onHide={() => setPaymentModel(false)}>
        <div className="min-h-screen flex items-center justify-center bg-gray-100">
          <div className="w-full md:w-2/3 lg:w-1/2 xl:w-1/3 p-4 bg-white rounded shadow-lg">
            <Elements
              stripe={stripePromise}
              options={{
                appearance: {theme: 'stripe'},
                clientSecret: clientSecret,
              }}>
                <Paymentform
              onclick={onclick}
                />
            </Elements>
          </div>
        </div>
        <Modal.Footer>
          <button
            className="btn btn-secondary"
            onClick={() => setPaymentModel(false)}>
            Cancel
          </button>
        </Modal.Footer>
      </Modal> */}
      </main>
    </div>
  );
};
export default Checkout;
